import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8d989888&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=8d989888&prod&lang=sass&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=8d989888&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d989888",
  null
  
)

export default component.exports